import util from '../util'

let controller = 'Autenticacao'
export default {
  AutenticarOperador: function (email, senha, tokenCaptcha) {
    var dto = { Email: email, Senha: senha , TokenCaptcha: tokenCaptcha}
    return util.Axios.Post(controller + '/Operador/AccessToken', dto)
  },
  LogoutOperador: function () {
    return util.Axios.DeleteAll(controller + '/Operador/AccessToken')
  },
  RefreshTokenOperador: function (token, webAuthResponse) {
    var dto = { RefreshToken: token, ChallengeRequest: webAuthResponse }
    return util.Axios.Post(controller + '/Operador/RefreshToken', dto)
  },
  ValidarToken: function (challengeResponse) {
    return util.Axios.Post(controller + '/mfafisico/validar', challengeResponse)
  }, 
  SolicitarValidacaoChave: function (dto) {
    return util.Axios.Get(controller + '/mfafisico/solicitar/validacao')
  }
}